export enum Role {
    User = 'User',
    Admin = 'Administrator',
    SiteManager = "Site Manager",
    RestrictedUser = "Restricted User",
    SuperUser = "Super User"
  }